// Displays required fields on WO template custom field modal
// - All state controlled by parent and passed through props

import { SetStateAction } from 'react';
import clsx from 'clsx';

import { DataType } from '@atom/types/dataType';

import classes from './workOrderFields.module.css';

interface WorkOrderModalRequiredFieldsProps {
  dataType: DataType;
  hasSubFields?: boolean;
  requiredOnCreate: boolean;
  required: boolean;
  selectAllOnCreateWork: boolean;
  selectAllOnCompleteWork: boolean;
  setSelectAllOnCreateWork: (value: SetStateAction<boolean>) => void;
  setSelectAllOnCompleteWork: (value: SetStateAction<boolean>) => void;
  setRequiredOnCreate: (value: SetStateAction<boolean>) => void;
  setRequired: (value: SetStateAction<boolean>) => void;
}

const WorkOrderModalRequiredFields = ({
  dataType,
  hasSubFields = false,
  requiredOnCreate,
  required,
  selectAllOnCreateWork,
  selectAllOnCompleteWork,
  setSelectAllOnCreateWork,
  setSelectAllOnCompleteWork,
  setRequiredOnCreate,
  setRequired,
}: WorkOrderModalRequiredFieldsProps) => {
  const cascadeLabel = hasSubFields ? ' (All cascading dropdowns)' : '';

  return (
    <>
      <div className={classes.requiredField}>
        <div>
          <input
            id="required-on-change"
            type="checkbox"
            checked={requiredOnCreate}
            onChange={event => setRequiredOnCreate(event.target.checked)}
          />
        </div>
        <label htmlFor="required-on-change">
          {`Required when creating work${cascadeLabel}`}
        </label>
      </div>
      {requiredOnCreate && dataType === DataType.ENUM_MULTIPLE && (
        <div className={clsx(classes.requiredField, classes.requiredInset)}>
          <div>
            <input
              id="required-select-any-on-create"
              name="required-select-on-create"
              type="radio"
              checked={!selectAllOnCreateWork}
              onClick={() => setSelectAllOnCreateWork(false)}
            />
          </div>
          <label htmlFor="required-select-any-on-create">Select Any</label>
          <div>
            <input
              id="required-select-all-on-create"
              name="required-select-on-create"
              type="radio"
              checked={selectAllOnCreateWork}
              onClick={() => setSelectAllOnCreateWork(true)}
            />
          </div>
          <label htmlFor="required-select-all-on-create">Select All</label>
        </div>
      )}
      <div className={classes.requiredField}>
        <div>
          <input
            id="required-on-complete"
            type="checkbox"
            checked={required}
            onChange={event => setRequired(event.target.checked)}
          />
        </div>
        <label htmlFor="required-on-complete">
          {`Required when completing or closing work${cascadeLabel}`}
        </label>
      </div>
      {required && dataType === DataType.ENUM_MULTIPLE && (
        <div className={clsx(classes.requiredField, classes.requiredInset)}>
          <div>
            <input
              id="required-select-any-on-complete"
              name="required-select-on-complete"
              type="radio"
              checked={!selectAllOnCompleteWork}
              onClick={() => setSelectAllOnCompleteWork(false)}
            />
          </div>
          <label htmlFor="required-select-any-on-complete">Select Any</label>
          <div>
            <input
              id="required-select-all-on-complete"
              name="required-select-on-complete"
              type="radio"
              checked={selectAllOnCompleteWork}
              onClick={() => setSelectAllOnCompleteWork(true)}
            />
          </div>
          <label htmlFor="required-select-all-on-complete">Select All</label>
        </div>
      )}
    </>
  );
};

export default WorkOrderModalRequiredFields;
